/* start activation */
import { TrackingCodeNudge } from '@hotjar/webapp/features/Activation/TrackingCodeNudge';
import { FeatureEmptyState } from '@hotjar/webapp/features/Activation/FeatureEmptyState';
import { HeatmapsEmptyStateCard } from '@hotjar/webapp/components/EmptyStateCard';
import {
    PendingFeedbackSetupState,
    PendingInstallationEmptyState,
    SurveysPendingInstallationEmptyState
} from '@hotjar/webapp/features/Activation/EmptyStates';
import { GrantAccessModal } from '@hotjar/webapp/features/Activation/GrantAccessModal';
/* end activation */

import { RegistrationFromInvite } from '@hotjar/webapp/features/Registration';
import { SuccessMessageWithIcon } from '@hotjar/webapp/features/Mfa/MessageWithIcon/SuccessMessageWithIcon';
import { ContactSalesBanner } from '@hotjar/webapp/features/Billing/ContactSalesBanner';
import { RatingSummary } from '@hotjar/webapp/features/Feedback/RatingSummary';

import { FeedbackSentimentGraph } from '@hotjar/webapp/features/Feedback/SentimentGraph';
import { ResponseCard } from '@hotjar/webapp/features/Feedback/Responses/ResponseCard';
import { FeedbackResponseModal } from '@hotjar/feedback/components/IncomingFeedback/Responses/FeedbackResponseModal';
// eslint-disable-next-line max-len
import { FeedbackEmptyState } from '@hotjar/feedback/components/IncomingFeedback/Responses/EmptyState/FeedbackEmptyState';

import { InvoicesAccessDenied, BillingAccessDenied } from '@hotjar/webapp/features/Settings/AccessDenied';
import { ModalSearchResultInfo } from '@hotjar/webapp/features/Settings/VisitorLookup/ModalSearchResultInfo';
import { ForgotPasswordPage } from '@hotjar/webapp/features/Password/ForgotPasswordPage';
import { ResetPasswordPage } from '@hotjar/webapp/features/Password/ResetPasswordPage';
import { Page40x } from '@hotjar/webapp/features/40xPage/40xPage';

import { PlansCostChange } from '@hotjar/webapp/features/Billing/PlansCostChange/PlansCostChange';

import { OrganizationList } from '@hotjar/webapp/features/Billing/OrganizationList/OrganizationList';
import {
    MoneyBackGuaranteeBanner,
    YearlyUpsellBanner,
    YearlyBillingCycleLockedBanner
} from '@hotjar/webapp/features/Billing/BillingAlerts';

import { wrappedR2A as react2angular } from '../other/wrapped-react2angular';

import { Avatar } from '@hotjar/webapp/components/Avatar';
// eslint-disable-next-line max-len

import { GenericMessageModal } from '@hotjar/webapp/components/GenericModal/GenericMessageModal';
import { PlansAndBillingHeader } from '@hotjar/webapp/features/Billing/PlansAndBillingHeader/PlansAndBillingHeader';
import { SubscriptionSummary } from '@hotjar/webapp/features/Billing/SubscriptionSummary/SubscriptionSummary';
import { PlanSelectDropdown } from '@hotjar/webapp/features/Billing/PlanSelectDropdown';
// eslint-disable-next-line max-len
import { MultiSkuComparisonLinks } from '@hotjar/webapp/features/Billing/MultiSkuComparisonLinks/MultiSkuComparisonLinks';

import { BillingNotifications } from '@hotjar/webapp/features/Billing/BillingNotifications/BillingNotifications';
import { InvoiceDetails } from '@hotjar/webapp/features/Billing/InvoiceDetails';
import { EnableMfaButton } from '@hotjar/webapp/features/Mfa/EnableMfaButton/EnableMfaButton';
import { DisableMfaButton } from '@hotjar/webapp/features/Mfa/DisableMfaButton/DisableMfaButton';
import { MfaEnableModal } from '@hotjar/webapp/features/Mfa/MfaEnable/MfaEnableModal';
import { MfaDisableModal } from '@hotjar/webapp/features/Mfa/MfaDisable/MfaDisableModal';
import { ContextualBanner } from '@hotjar/webapp/features/Billing/ContextualBanner';

import { ConditionalFeatureGroupBadge } from '@hotjar/webapp/containers/ConditionalFeatureGroupBadge';

import { ExportResults } from '@hotjar/feedback/components/common/ExportResults';
import { ViewMode } from '@hotjar/webapp/components/TableActions/ViewMode/ViewMode';
import { ForwardResults } from '@hotjar/feedback/components/common/ForwardResults';
import { ListCounter } from '@hotjar/feedback/components/common/ListCounter';

import { Login } from '@hotjar/webapp/features/Login';

import { Alert, Pagination, Button, Loader } from '@hotjar/hotsauce';

import { MaintenancePage } from '@hotjar/insights-common/components/MaintenancePage';
import { TeamListPage } from '@hotjar/webapp/features/Settings/Team/TeamList/TeamListPage';
import { TeamInvitePage } from '@hotjar/webapp/features/Settings/Team/TeamInvite/TeamInvitePage';
import { MfaTrustedDevices } from '@hotjar/webapp/features/Mfa/MfaTrustedDevices';

/* Start Feedback components */

import {
    LimitAlerts,
    WidgetLimitAlert,
    WidgetLabelField,
    SummarySection,
    SurveyWizard,
    SurveyWizardAccordion
} from '@hotjar/feedback';

// eslint-disable-next-line max-len
import { ResponsesList as FeedbackResponsesList } from '@hotjar/webapp/features/Feedback/Responses/ResponsesList/ResponsesList';
import { ForwardFeedback } from '@hotjar/webapp/features/Feedback/ForwardFeedback';
import { StepsSection } from '@hotjar/webapp/features/Feedback/FeedbackWizard';
import { EmotionStyleSelectorGate } from '@hotjar/webapp/features/Feedback/FeedbackWizard';

import { TabsNav as FeedbackTabsNav } from '@hotjar/feedback/components/IncomingFeedback/TabsNav';
// eslint-disable-next-line max-len
import { AlternateColor } from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Sections/Appearance/AlternateColor';
// eslint-disable-next-line max-len
import { WidgetSummary } from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Sections/Summary/WidgetSummary';
import { PagesTargeting } from '@hotjar/feedback/components/common/Wizard/PagesTargeting';
import { TargetingSection } from '@hotjar/feedback/components/Surveys/Wizard/Targeting/TargetingSection';
// eslint-disable-next-line max-len
import { UserAttributesTargeting } from '@hotjar/feedback/components/common/Wizard/UserAttributesTargeting/UserAttributesTargeting';
import { MultipleWidgetHelp } from '@hotjar/feedback/components/common/Wizard/MultipleWidgetHelp';
import { BrandingToggle } from '@hotjar/feedback/components/common/Wizard/BrandingToggle';
// eslint-disable-next-line max-len
import { QuestionsSection } from '@hotjar/feedback/components/Surveys/Wizard/Questions/QuestionsSection/QuestionsSection';
import { TrafficCoverage } from '@hotjar/feedback/components/common/Wizard/TrafficCoverage';
// eslint-disable-next-line max-len
import {
    PositionSelector,
    EmbedParentSelector
} from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Sections/Appearance';
import { DeviceSelector } from '@hotjar/feedback/components/common/Wizard/DeviceSelector';
import { DetailsSection } from '@hotjar/feedback/components/common/Wizard/Sections/Details/DetailsSection';
import { AppearanceSection } from '@hotjar/feedback/components/Surveys/Wizard/Sections/Appearance/AppearanceSection';
// eslint-disable-next-line max-len
import { SurveyLocation } from '@hotjar/feedback/components/Surveys/Wizard/Location/SurveyLocation';
import { LanguageSelector } from '@hotjar/feedback/components/common/Wizard/LanguageSelector';
// eslint-disable-next-line max-len
import { ResponsesFilters as IncomingFeedbackResponsesFilters } from '@hotjar/feedback/components/IncomingFeedback/ResponsesFilters/ResponsesFilters';
// eslint-disable-next-line max-len
import { FeedbackResponsesHeader } from '@hotjar/feedback/components/IncomingFeedback/Responses/FeedbackResponsesHeader';
import { FeedbackSideBar } from '@hotjar/feedback/components/IncomingFeedback/Spaces/FeedbackSideBar';
import { SurveyWizardHeader } from '@hotjar/feedback/components/Surveys/Wizard/Header';
// eslint-disable-next-line max-len
import { SurveyWizardFullScreenHeader } from '@hotjar/feedback/components/Surveys/Wizard/Header/SurveyWizardFullScreenHeader';
// eslint-disable-next-line max-len
import { AccentColorSectionGate } from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Sections/Appearance/AccentColor';
// eslint-disable-next-line max-len
import { FeedbackWizardFullScreenHeader } from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Header/FeedbackWizardFullScreenHeader';
import { FeedbackWizardHeader } from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Header';
import { BehaviorSection, BehaviorSummary } from '@hotjar/feedback/components/Surveys/Wizard/Behavior';
import { FeedbackType } from '@hotjar/feedback/components/Feedback/Wizard/Type/FeedbackType';
import { SurveyInvitation } from '@hotjar/feedback/components/Surveys/Wizard/Invitation';

import { WidgetPreview } from '@hotjar/feedback/components/common/Wizard/WidgetPreview';
/* End Feedback components */

import { FoundingMemberBadge } from '@hotjar/webapp/features/Settings/Account/FoundingMemberBadge';
import { Logo } from '@hotjar/webapp/features/Settings/Account/Logo';

import { TransferOwnershipSection } from '@hotjar/webapp/features/Settings/Account/TransferOwnershipSection';

import { ItemUnavailableRoute, NoSiteAccessRoute } from '@hotjar/webapp-routing';

angular.module('hjApp.react', []);

angular
    .module('hjApp.react')
    // Components
    .component(
        'reactAvatar',
        react2angular(Avatar, ['format', 'name', 'url', 'userRole', 'size', 'hideTooltip', 'outline'])
    )
    .component(
        'reactWidgetPreview',
        react2angular(WidgetPreview, [
            'hidePreviewActions',
            'showBrowserFrame',
            'showDeviceSelector',
            'widget',
            'widgetConfig',
            'iframeId'
        ])
    )
    .component(
        'reactForwardFeedback',
        react2angular(ForwardFeedback, [
            'email',
            'slack',
            'msTeams',
            'webhooks',
            'zapier',
            'onChange',
            'siteId',
            'feedbackId'
        ])
    )
    .component(
        'reactFeedbackResponsesList',
        react2angular(FeedbackResponsesList, [
            'feedbackId',
            'responses',
            'sortString',
            'onSortChanged',
            'onViewResponseClicked',
            'onDeleteResponseClicked',
            'onFeedbackChanged',
            'emotionStyle',
            'coveragePercentage'
        ])
    )
    .component(
        'reactSurveyWizard',
        react2angular(SurveyWizard, [
            'allQuestions',
            'areQuestionsValid',
            'autoValidate',
            'backgroundColor',
            'buttonColor',
            'connectVisitData',
            'context',
            'description',
            'devices',
            'displayCondition',
            'displayDelay',
            'displayType',
            'displayType',
            'email',
            'emailLimitsHelpUrl',
            'entityType',
            'errors',
            'featureGroup',
            'fontColor',
            'forwardingEmailAddresses',
            'forwardingEmailEnabled',
            'forwardingMsTeamsEnabled',
            'forwardingMsTeamsWebhookUrls',
            'forwardingSlackChannels',
            'forwardingSlackEnabled',
            'hasLegalDetails',
            'hasSurveyResponses',
            'highlightReviewSection',
            'iframeId',
            'invitation',
            'inviteEnabled',
            'inviteEnabled',
            'isAbandonDisabled',
            'isActive',
            'isDataFromTemplate',
            'isFormDirty',
            'isLoaded',
            'isOffsite',
            'isPopoverSurvey',
            'isSaving',
            'isThankYouValid',
            'isValidateEnabled',
            'language',
            'logoError',
            'logoSource',
            'mode',
            'msTeams',
            'msTeamsSelectedQuestions',
            'name',
            'onAddNewQuestion',
            'onAddQuestionFromQuestionBank',
            'onAddRule',
            'onChangeBackgroundColor',
            'onChangeBranding',
            'onChangeButtonColor',
            'onChangeFontColor',
            'onChangeLogo',
            'onChangeOrder',
            'onChangeRule',
            'onConnectVisitDataChange',
            'onDescriptionChanged',
            'onDevicesChanged',
            'onDisplayConditionChanged',
            'onDisplayDelayChanged',
            'onDisplayTypeChange',
            'onExit',
            'onForwardSurveyChange',
            'onInvitationChange',
            'onLanguageChanged',
            'onMsTeamsQuestionsChange',
            'onNameChanged',
            'onNavigateClicked',
            'onPagesTargetingChange',
            'onPagesTargetingUpsell',
            'onPercentageChanged',
            'onPersistConditionChanged',
            'onPositionChange',
            'onPreviewBackgroundColor',
            'onPreviewButtonColor',
            'onPreviewFontColor',
            'onPreviewReaction',
            'onRemoveLogo',
            'onRemoveQuestion',
            'onRemoveRule',
            'onShowLegalChange',
            'onShowUpsellModal',
            'onSlackQuestionsChange',
            'onSurveyStatusChange',
            'onTargetingModeChange',
            'onThankYouMessageChange',
            'onTrafficCoverageUpsell',
            'onUpdateQuestion',
            'pagesTargeting',
            'persistCondition',
            'pollId',
            'position',
            'positionOptions',
            'previewConfig',
            'questions',
            'reloadPreview',
            'responseCount',
            'reviewHidden',
            'save',
            'saveEnabled',
            'setInviteEnabled',
            'showBranding',
            'showBrowserFrame',
            'showDeviceSelector',
            'showDisplaySettings',
            'showErrors',
            'showFontColor',
            'showLegal',
            'showSurveyPosition',
            'siteId',
            'slack',
            'slackSelectedQuestions',
            'surveyId',
            'targeting',
            'targetingMode',
            'targetingPercentage',
            'targetingRules',
            'thankYouMessage',
            'userAttributes',
            'widgetConfig'
        ])
    )
    .component(
        'reactSurveyInvite',
        react2angular(SurveyInvitation, ['invitation', 'enabled', 'onChange', 'setInviteEnabled', 'showBranding'])
    )

    .component('reactSurveyLocation', react2angular(SurveyLocation, ['value', 'onChange']))
    .component(
        'reactExportResults',
        react2angular(ExportResults, ['csv', 'xlsx', 'onExportSelected', 'isDisabled', 'disabledTooltip'])
    )
    .component('reactViewMode', react2angular(ViewMode, ['list', 'card', 'onViewModeSelected', 'currentMode']))
    .component(
        'reactFeedbackSentimentGraph',
        react2angular(FeedbackSentimentGraph, ['averageDailySentiment', 'emotionStyle', 'dailyResponseCount'])
    )
    .component('reactFeedbackWizardAlternateColor', react2angular(AlternateColor, ['theme', 'onChange']))
    .component(
        'reactFeedbackWizardSummary',
        react2angular(WidgetSummary, [
            'isValid',
            'previewConfig',
            'isActive',
            'targeting',
            'pageTargetingMode',
            'usersTargetingMode',
            'trafficCoverage',
            'jumpToSection',
            'forwardToSlackSettings',
            'forwardToMsTeamsSettings',
            'forwardToWebhooksSettings',
            'forwardToEmailSettings',
            'widgetName',
            'widgetDescription',
            'onSave',
            'onStatusChange',
            'saveInProgress',
            'mode',
            'hasNameErrors',
            'hasAppearanceErrors',
            'hasTargetingErrors',
            'hasStepsErrors'
        ])
    )
    .component(
        'reactWizardPagesTargeting',
        react2angular(PagesTargeting, [
            'pagesTargeting',
            'onChange',
            'onAddRule',
            'onRemoveRule',
            'targetingRules',
            'onUpsell',
            'autoValidate',
            'entityType'
        ])
    )
    .component(
        'reactTargetingSection',
        react2angular(TargetingSection, [
            'targeting',
            'hasErrors',
            'isOffsite',
            'autoValidate',
            'userAttributes',
            'onTargetingChange',
            'onUpsell'
        ])
    )
    .component('reactMultipleWidgetHelp', react2angular(MultipleWidgetHelp))
    .component(
        'reactWizardUserAttributesTargeting',
        react2angular(UserAttributesTargeting, [
            'targetingMode',
            'onTargetingModeChange',
            'onAddRule',
            'onRemoveRule',
            'onChangeRule',
            'targetingRules',
            'userAttributes',
            'onShowUpsellModal',
            'entityType'
        ])
    )
    .component('reactWizardBrandingToggle', react2angular(BrandingToggle, ['hideBranding', 'onChange', 'onShowUpsell']))
    .component(
        'reactFeedbackResponseCard',
        react2angular(ResponseCard, [
            'emotionStyle',
            'feedbackWidgetId',
            'onAddComment',
            'onClick',
            'onDelete',
            'onFeedbackVote',
            'onShowComments',
            'organizationUsers',
            'response',
            'siteId',
            'coveragePercentage'
        ])
    )
    .component(
        'reactFeedbackResponsesFilters',
        react2angular(IncomingFeedbackResponsesFilters, [
            'filters',
            'onChange',
            'onRemoveFilter',
            'emotionStyle',
            'hideRatingFilter',
            'onUpsellRequest'
        ])
    )
    .component('reactFeedbackResponsesHeader', react2angular(FeedbackResponsesHeader, ['widgetId']))
    .component(
        'reactFeedbackResponseModal',
        react2angular(FeedbackResponseModal, [
            'isOpen',
            'onClose',
            'showNextButton',
            'showPreviousButton',
            'onLoadNext',
            'onLoadPrevious',
            'siteId',
            'feedbackId',
            'response',
            'emotionStyle',
            'commentsProps',
            'coveragePercentage',
            'onClose',
            'onDelete',
            'onFeedbackChange'
        ])
    )
    .component('reactFeedbackSideBar', react2angular(FeedbackSideBar, ['selectedWidget']))
    .component(
        'reactBehaviorSummary',
        react2angular(BehaviorSummary, ['showDisplaySummary', 'displayCondition', 'displayDelay', 'persistCondition'])
    )
    .component(
        'reactBehaviorSection',
        react2angular(BehaviorSection, [
            'isOffsite',
            'displayCondition',
            'onDisplayConditionChanged',
            'persistCondition',
            'onPersistConditionChanged',
            'displayDelay',
            'onDisplayDelayChanged',
            'isAbandonDisabled',
            'showDisplaySettings'
        ])
    )
    .component('reactFeedbackTabsNav', react2angular(FeedbackTabsNav, ['onTabClick', 'selectedValue']))
    .component(
        'reactFeedbackEmptyDataState',
        react2angular(FeedbackEmptyState, ['resetFilters', 'isDefaultRange', 'changeRange', 'isEmptyState'])
    )
    .component(
        'reactSubscriptionSummary',
        react2angular(SubscriptionSummary, [
            'account',
            'subscriptionInfo',
            'status',
            'onEditPayment',
            'onDeletePayment',
            'onUpdatePayment',
            'onChangeSubscription',
            'subscriptionPriceSummary'
        ])
    )
    .component('reactContactSalesBanner', react2angular(ContactSalesBanner))
    .component('reactPlanSelectDropdown', react2angular(PlanSelectDropdown, ['activePlanId', 'account', 'onChange']))
    .component(
        'reactMultiSkuComparisonLinks',
        react2angular(MultiSkuComparisonLinks, [
            'productCatalog',
            'onChange',
            'activeFeedbackProductSku',
            'activeAnalyticsProductSku',
            'siteAccount'
        ])
    )
    .component('reactInvoicesAccessDenied', react2angular(InvoicesAccessDenied))
    .component('reactBillingAccessDenied', react2angular(BillingAccessDenied))
    .component('react40xPage', react2angular(Page40x, ['title', 'description', 'imgSrc', 'redirectToLoginPage']))

    .component(
        'reactForgotPasswordPage',
        react2angular(ForgotPasswordPage, ['onError', 'trackFormSubmit', 'redirectToLogin'])
    )
    .component('reactResetPasswordPage', react2angular(ResetPasswordPage, ['version']))

    // Modals
    .component(
        'reactMfaEnableModal',
        react2angular(MfaEnableModal, [
            'userId',
            'userEmail',
            'onClickChangeEmail',
            'isOpen',
            'onClose',
            'onEnabled',
            'isEmailVerified',
            'onEmailVerified'
        ])
    )
    .component('reactMfaDisableModal', react2angular(MfaDisableModal, ['userId', 'isOpen', 'onClose', 'onDisabled']))
    .component(
        'reactGenericMessageModal',
        react2angular(GenericMessageModal, ['isOpen', 'size', 'title', 'description', 'submit', 'cancel'])
    )
    .component('reactModalSearchResultInfo', react2angular(ModalSearchResultInfo, ['isOpen', 'setOpen', 'onSubmit']))
    .component(
        'reactConditionalFeatureGroupBadge',
        react2angular(ConditionalFeatureGroupBadge, ['kind', 'onClick', 'size', 'isInTrial'])
    )
    .component(
        'reactPlansCostChange',
        react2angular(PlansCostChange, [
            'account',
            'updateSubscription',
            'cancelPlanChanges',
            'submitting',
            'isDisabled',
            'changedPlans',
            'changedPlansCost'
        ])
    )
    .component(
        'reactOrganizationList',
        react2angular(OrganizationList, ['organizations', 'onPlanChange', 'onCancelDowngrade', 'updatedSitePriceInfo'])
    )
    .component('reactPlansAndBillingHeader', react2angular(PlansAndBillingHeader))
    // Pages
    .component('reactBillingNotifications', react2angular(BillingNotifications, []))
    .component('reactInvoiceDetails', react2angular(InvoiceDetails, ['companyDetails', 'onEdit']))
    .component('reactLogin', react2angular(Login, []))
    .component('reactTrackingCodeNudge', react2angular(TrackingCodeNudge, ['toolName', 'noSidePadding']))
    .component('reactFeatureEmptyState', react2angular(FeatureEmptyState, ['kind']))
    .component(
        'reactRegistrationFromInvite',
        react2angular(RegistrationFromInvite, [
            'onGoogleBtnClick',
            'onSubmitBtnClick',
            'isInvalidToken',
            'organizationName',
            'email',
            'name',
            'isLoading',
            'isSsoError',
            'emailExists',
            'loggedInAs',
            'isAuthenticatedWithGoogle',
            'isGoogleSsoError'
        ])
    )
    .component('reactGrantAccessModal', react2angular(GrantAccessModal, []))
    .component('reactPendingInstallationEmptyState', react2angular(PendingInstallationEmptyState, []))
    .component(
        'reactSurveysPendingInstallationEmptyState',
        react2angular(SurveysPendingInstallationEmptyState, ['onSkip'])
    )
    .component('reactHeatmapsEmptyStateCard', react2angular(HeatmapsEmptyStateCard))
    .component('reactSuccessMessageWithIcon', react2angular(SuccessMessageWithIcon, ['message']))
    .component(
        'reactForwardResults',
        react2angular(ForwardResults, [
            'siteId',
            'widgetType',
            'onEdit',
            'hasEmailForwarding',
            'hasSlackForwarding',
            'hasMsTeamsForwarding',
            'widgetId',
            'emailEnabled',
            'trackingUiPosition',
            'trackingState'
        ])
    )
    .component(
        'reactDsButton',
        react2angular(Button, [
            'size',
            'onClick',
            'isDisabled',
            'isLoading',
            'loadingText',
            'children',
            'as',
            'href',
            'kind',
            'icon'
        ])
    )
    .component(
        'reactPagination',
        react2angular(Pagination, [
            'totalCount',
            'currentPage',
            'withSpacer',
            'onPageChange',
            'pageSize',
            'onPageSizeChange'
        ])
    )
    .component('reactListCounter', react2angular(ListCounter, ['count', 'totalCount']))
    .component(
        'reactAlert',
        react2angular(Alert, [
            'kind',
            'title',
            'children',
            'isDismissible',
            'actionText',
            'actionHref',
            'onDismiss',
            'onAction'
        ])
    )
    .component('reactLoader', react2angular(Loader, ['className', 'isGreyScale', 'isLoading', 'size']))
    .component('reactMoneyBackGuaranteeBanner', react2angular(MoneyBackGuaranteeBanner, []))
    .component('reactYearlyUpsellBanner', react2angular(YearlyUpsellBanner, ['onYearlyUpsellClick']))
    .component(
        'reactYearlyBillingCycleLockedBanner',
        react2angular(YearlyBillingCycleLockedBanner, ['onContactCustomerSuccessLinkClick'])
    )
    .component('reactPendingFeedbackSetupState', react2angular(PendingFeedbackSetupState, ['onButtonClick']))
    .component(
        'reactRatingSummary',
        react2angular(RatingSummary, [
            'emotionStyle',
            'averageSentiment',
            'responsesCount',
            'sentimentCount',
            'onRatingClicked'
        ])
    )
    .component('reactPositionSelector', react2angular(PositionSelector, ['position', 'onChange']))
    .component(
        'reactEmbedParentSelector',
        react2angular(EmbedParentSelector, ['parentElementSelector', 'onChange', 'autoValidate'])
    )
    .component(
        'reactFeedbackAccentColorSectionGate',
        react2angular(AccentColorSectionGate, ['color', 'showReset', 'onColorChange', 'onColorReset', 'onShowUpsell'])
    )
    .component('reactWidgetLabelField', react2angular(WidgetLabelField, ['widgetLabel', 'onWidgetLabelChange']))
    .component('reactFeedbackWizardHeader', react2angular(FeedbackWizardHeader, ['mode', 'name']))
    .component(
        'reactSurveyWizardHeader',
        react2angular(SurveyWizardHeader, ['mode', 'name', 'responseCount', 'surveyId'])
    )
    .component(
        'reactSurveyWizardFullScreenHeader',
        react2angular(SurveyWizardFullScreenHeader, [
            'isLoaded',
            'surveyId',
            'mode',
            'save',
            'saveEnabled',
            'reviewHidden',
            'highlightReviewSection',
            'isSaving',
            'isFormDirty',
            'onExit'
        ])
    )
    .component(
        'reactFeedbackWizardFullScreenHeader',
        react2angular(FeedbackWizardFullScreenHeader, [
            'isLoaded',
            'widgetId',
            'mode',
            'save',
            'saveEnabled',
            'highlightReviewSection',
            'isSaving',
            'isFormDirty'
        ])
    )
    .component(
        'reactQuestionsSection',
        react2angular(QuestionsSection, [
            'connectVisitData',
            'onConnectVisitDataChange',
            'reloadPreview',
            'previewConfig',
            'questions',
            'thankYouMessage',
            'language',
            'onThankYouMessageChange',
            'onAddQuestionFromQuestionBank',
            'onAddNewQuestion',
            'onRemoveQuestion',
            'onUpdateQuestion',
            'onShowLegalChange',
            'onChangeOrder',
            'onPreviewReaction',
            'isValidateEnabled',
            'isThankYouValid',
            'isPopoverSurvey',
            'isDataFromTemplate',
            'hasLegalDetails',
            'hasSurveyResponses',
            'showLegal',
            'areQuestionsValid'
        ])
    )
    .component(
        'reactDetailsSection',
        react2angular(DetailsSection, ['description', 'name', 'onNameChanged', 'onDescriptionChanged', 'showErrors'])
    )
    .component(
        'reactSummarySection',
        react2angular(SummarySection, [
            'areAllVisibleSectionsValid',
            'name',
            'description',
            'questions',
            'displayType',
            'targeting',
            'targetingPercentage',
            'forwardingEmailAddresses',
            'forwardingEmailEnabled',
            'forwardingSlackChannels',
            'forwardingSlackEnabled',
            'forwardingMsTeamsWebhookUrls',
            'forwardingMsTeamsEnabled',
            'forwardingWebhooksEnabled',
            'forwardingWebhooksUrls',
            'errors',
            'mode',
            'onNavigateClicked',
            'isActive',
            'onChange',
            'reloadPreview',
            'isSaving',
            'onSave',
            'onCopy'
        ])
    )
    .component(
        'reactWizardLanguageSelector',
        react2angular(LanguageSelector, ['type', 'language', 'onLanguageChanged'])
    )
    .component(
        'reactEmotionStyleSelectorGate',
        react2angular(EmotionStyleSelectorGate, [
            'emotionStyle',
            'emotionStyleOptions',
            'onEmotionStyleChanged',
            'onReloadPreview'
        ])
    )
    .component(
        'reactTrafficCoverage',
        react2angular(TrafficCoverage, ['widget', 'percentage', 'onPercentageChanged', 'onUpsell'])
    )
    .component('reactEnableMfaButton', react2angular(EnableMfaButton, ['onClick', 'isVisible', 'isPopoverVisible']))
    .component('reactDisableMfaButton', react2angular(DisableMfaButton, ['onClick', 'isVisible', 'isMfaEnforced']))
    .component('reactMfaTrustedDevices', react2angular(MfaTrustedDevices, []))
    .component(
        'reactStepsSection',
        react2angular(StepsSection, [
            'onValidateForm',
            'onReloadPreview',
            'widgetPosition',
            'invitationMessage',
            'onInvitationMessageChanged',
            'mainQuestion',
            'autoScreenshot',
            'showAdditionalMessage',
            'additionalMessage',
            'onMainQuestionChanged',
            'onToggleAdditionalMessage',
            'onToggleAutoScreenshot',
            'onAdditionalMessageChanged',
            'showEmailRequest',
            'emailRequest',
            'onToggleEmailRequest',
            'onEmailRequestChanged',
            'thankyouMessage',
            'showLegal',
            'siteHasLegalDetails',
            'connectFeedback',
            'onThankyouMessageChanged',
            'onToggleLegal',
            'onConnectFeedbackChanged',
            'isRtlLanguage'
        ])
    )
    .component('reactDeviceSelector', react2angular(DeviceSelector, ['devices', 'onDevicesChanged', 'context']))
    .component(
        'reactLimitAlerts',
        react2angular(LimitAlerts, ['location', 'featureGroup', 'skippedInstallation', 'hidePricingAlert'])
    )
    .component('reactBillingContextualBanner', react2angular(ContextualBanner, []))
    .component('reactWidgetLimitAlert', react2angular(WidgetLimitAlert, ['featureGroup']))
    .component('reactMaintenancePage', react2angular(MaintenancePage), [])
    .component('reactTeamListPage', react2angular(TeamListPage), [])
    .component('reactTeamInvitePage', react2angular(TeamInvitePage, ['organizationId']))
    .component('reactFeedbackType', react2angular(FeedbackType, ['displayType', 'onChange']))
    .component('reactNoSiteAccessRoute', react2angular(NoSiteAccessRoute, []))
    .component('reactItemUnavailableRoute', react2angular(ItemUnavailableRoute, []))
    .component(
        'reactAppearanceSection',
        react2angular(AppearanceSection, [
            'language',
            'onLanguageChanged',
            'backgroundColor',
            'onChangeBackgroundColor',
            'onPreviewBackgroundColor',
            'buttonColor',
            'onChangeButtonColor',
            'onPreviewButtonColor',
            'fontColor',
            'onChangeFontColor',
            'onPreviewFontColor',
            'showFontColor',
            'showSurveyPosition',
            'position',
            'positionOptions',
            'onPositionChange',
            'showLogoSection',
            'logoSource',
            'logoError',
            'onChangeLogo',
            'onRemoveLogo',
            'hideBranding',
            'onChangeBranding'
        ])
    )
    .component('reactFoundingMemberBadge', react2angular(FoundingMemberBadge, []))
    .component('reactAccountLogo', react2angular(Logo, []))
    .component(
        'reactSurveyWizardAccordion',
        react2angular(SurveyWizardAccordion, [
            'activeSection',
            'onChangeActiveSection',
            'hiddenSections',
            'openedSections',
            'onToggleSection',
            'isNameValid',
            'isLocationValid',
            'isQuestionsValid',
            'isAppearanceValid',
            'isInvitationValid',
            'isTargetingValid',
            'isBehaviorValid',
            'isForwardingValid',
            'name',
            'description',
            'showErrors',
            'onNameChanged',
            'onDescriptionChanged',
            'location',
            'onChangeLocation',
            'connectVisitData',
            'onConnectVisitDataChange',
            'reloadPreview',
            'previewConfig',
            'questions',
            'thankYouMessage',
            'language',
            'onThankYouMessageChange',
            'onAddQuestionFromQuestionBank',
            'onAddNewQuestion',
            'onRemoveQuestion',
            'onUpdateQuestion',
            'onShowLegalChange',
            'onChangeOrder',
            'onPreviewReaction',
            'isValidateEnabled',
            'isThankYouValid',
            'isPopoverSurvey',
            'isDataFromTemplate',
            'hasLegalDetails',
            'hasSurveyResponses',
            'showLegal',
            'areQuestionsValid',
            'onLanguageChanged',
            'backgroundColor',
            'onChangeBackgroundColor',
            'onPreviewBackgroundColor',
            'buttonColor',
            'onChangeButtonColor',
            'onPreviewButtonColor',
            'fontColor',
            'onChangeFontColor',
            'onPreviewFontColor',
            'showSurveyPosition',
            'position',
            'positionOptions',
            'onPositionChange',
            'logoSource',
            'logoError',
            'onChangeLogo',
            'onRemoveLogo',
            'hideBranding',
            'onChangeBranding',
            'hidePreviewActions',
            'showBrowserFrame',
            'widget',
            'widgetConfig',
            'iframeId',
            'invitation',
            'isInvitationEnabled',
            'onInvitationChange',
            'setInviteEnabled',
            'isOffsite',
            'displayCondition',
            'displayDelay',
            'onDisplayConditionChanged',
            'onDisplayDelayChanged',
            'persistCondition',
            'onPersistConditionChanged',
            'isAbandonDisabled',
            'allQuestions',
            'slackSelectedQuestions',
            'msTeamsSelectedQuestions',
            'onSlackQuestionsChange',
            'onMsTeamsQuestionsChange',
            'slack',
            'email',
            'msTeams',
            'zapier',
            'onChange',
            'emailLimitsHelpUrl',
            'siteId',
            'pollId',
            'activeForwardingNames',
            'mode',
            'targeting',
            'onTargetingChange',
            'hasTargetingErrors',
            'onUpsell',
            'userAttributes',
            'targetingAutoValidate',
            'isDisabled',
            'targetingPercentage',
            'onTargetingPercentageChange',
            'areAllVisibleSectionsValid',
            'errors',
            'forwardingEmailAddresses',
            'forwardingEmailEnabled',
            'forwardingMsTeamsEnabled',
            'forwardingMsTeamsWebhookUrls',
            'forwardingSlackChannels',
            'forwardingSlackEnabled',
            'isActive',
            'isSaving',
            'onStatusChange',
            'onCopy',
            'onNavigateClicked',
            'onSave',
            'webhooks',
            'forwardingWebhooksEnabled',
            'forwardingWebhooksUrls'
        ])
    )
    .component('reactTransferOwnershipSection', react2angular(TransferOwnershipSection, []));
